export default "__VITE_ASSET__BV_EEVa7__"